import React from 'react';

import { BaseGanttCell } from './styled-gantt.components';

import type { DayProps } from '../types';

type MonthCellProps = {
  day: DayProps['day'];
  month: DayProps['month'];
  year: DayProps['year'];
  isToday: DayProps['isToday'];
  weekDay: DayProps['weekDay'];
  isWeekend: DayProps['isWeekend'];
};

const MonthCellComponent: React.FC<MonthCellProps> = ({
  day,
  month,
  year,
  isToday,
  weekDay,
  isWeekend,
}) => {
  return (
    <BaseGanttCell
      id={isToday ? 'today' : `${day}-${month}-${year}`}
      data-today={isToday}
      data-weekend={isWeekend}
      data-day={weekDay}
    >
      {weekDay}

      <br />

      {day}
    </BaseGanttCell>
  );
};

export const MonthCell = React.memo(MonthCellComponent);
